import React, { useState, useRef, useEffect, useContext } from 'react';
import './hidescrollbarx.css';
import { HighlisghtVideosApi } from '../../Services/allApi';
import { useNavigate } from 'react-router-dom';
import { addcontext } from '../../ContextShare/ContextShare';
import dummyThumbnail from '../../Assets/NIYAMASABHAMANDIRAM 03.jpg'
import language from '../../language.json'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import './LatestSession.css'; // Import the CSS for overlay

function ExclusiveVideos() {
    const baseUrl = process.env.REACT_APP_BASEURL
    const altimg = process.env.REACT_APP_ALT_IMG;
    const [currentLanguage, setCurrentLanguage] = useState();
    const { langChanged, setlangChanged } = useContext(addcontext)
    const { videoUrl, setVideoUrl } = useContext(addcontext)
    const { videoThumb, setVideoThumb } = useContext(addcontext)
    const { videoData, setVideoData } = useContext(addcontext)
    const { whichPageIsSendingData, setwhichPageIsSendingData } = useContext(addcontext)
    const [Highlisghvideos, setHighlisghvideos] = useState([]);
    const scrollContainerRef = useRef(null);
    const [errorMessage, setErrorMessage] = useState()
    
    // handle scroll left
    const scrollLeft = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({
                left: -500,
                behavior: 'smooth',
            });
        }
    };

    // handle scroll right
    const scrollRight = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({
                left: 500,
                behavior: 'smooth',
            });
        }
    };
    
    // get the highlighe videos API
    const getHighlights = async () => {
        try {
            const result = await HighlisghtVideosApi()
            console.log(result);
            setTimeout(() => {
                setHighlisghvideos(result?.data)

            }, 500)
            setErrorMessage(result?.response?.data?.message)
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        getHighlights()
    }, [])

    const navigate = useNavigate()
    // redirect to video play page pn click
    const handleVideoUrl = (e) => {
        setVideoUrl(e.video_url)
        setVideoThumb(e.video_thumbnail)
        setVideoData(e)
        // setwhichPageIsSendingData('highlights')
        // navigate('/video')
        if (e?.mapping_id) {
            console.log(e?.mapping_id);
            navigate(`/video/:${e?.mapping_id}`);
        }
    }


    useEffect(() => {
        setCurrentLanguage(localStorage.getItem('language') || 'en')
    }, [currentLanguage, langChanged])

    return (
        <div className='flex flex-row' style={{ backgroundColor: '#D3D3D3' }}>
            <div className='w-1/12 flex justify-center items-center' >
                <i className="fa-solid fa-chevron-left fa-xl" onClick={scrollLeft} style={{ cursor: 'pointer' }} title='Scroll Left'></i>
            </div>

            <div className="flex flex-col m-auto p-auto w-10/12" style={{ fontFamily: "Ropa Sans" }}>
                <h1 className="flex py-5 font-bold text-4xl  lg:justify-start justify-center" style={{ color: '#001F33' }}>

                    {language.highlights[currentLanguage]}

                </h1>
                {Highlisghvideos?.length > 0 ? <div className="flex overflow-x-scroll pb-10 hide-scroll-bar" ref={scrollContainerRef}>
                    <div className="flex flex-nowrap mt-10">
                        {Highlisghvideos?.length > 0 && Highlisghvideos?.map(videovalues => (
                            <div className="inline-block me-20" >
                                <div onClick={() => handleVideoUrl(videovalues)} style={{ width: '460px' }} className="h-80 overflow-hidden hover:shadow-xl transition-shadow duration-300 ease-in-out rounded relative">
                                    <img
                                        src={videovalues?.video_thumbnail ? `${baseUrl}${videovalues.video_thumbnail}` : altimg}
                                        // src={dummyThumbnail}
                                        alt='image'
                                        style={{ width: '100%', height: '90%', }}
                                        className='' />
                                    <div className='txts flex flex-row justify-between'>
                                        <h2 className='ms-2 mt-1' style={{ color: '#001F33' }}>{currentLanguage == 'en' ? videovalues?.video_event : videovalues?.malayalam_video_event}</h2>
                                        <h5 className='me-2 text-xs items-center mt-2 text-slate-500'>{videovalues.video_upload_date}</h5>
                                    </div>
                                    <div className="overlay flex flex-col">
                                                <div className="overlay-text">
                                                    {currentLanguage == 'en' ? videovalues?.video_event : videovalues?.malayalam_video_event}
                                                </div>
                                                <div className="overlay-text">
                                                {videovalues?.video_upload_date}
                                                </div>

                                                <div className='flex flex-row justify-center gap-5 w-full mt-1'>
                                               
                                                <div className='text-white text-sm'>
                                                {language.kla[currentLanguage]} :{videovalues?.kla}
                                                </div>

                                                <div className='text-white text-sm'>
                                                {language.Session[currentLanguage]} :{videovalues?.video_session}
                                                </div>
                                                </div>

                                            </div>
                                </div>
                            </div>
                        ))
                        }
                    </div>
                </div>
                    :

                    <>
                        {errorMessage?<div className="flex flex-col justify-center items-center">

                            <p className="text-red-800 text-lg font-semibold mt-4 text-center">{errorMessage}</p>
                        </div>
                   
                    :
            
            <div className='flex flex-row md:justify-between justify-center pb-10 pt-5 overflow-hidden'>

                <div className='md:flex hidden flex-col'>
                    <Skeleton height={285} width={600} />
                    <div className='flex flex-row justify-between'>
                        <Skeleton height={10} width={400} />
                        <Skeleton height={10} width={190} />
                    </div>
                </div>

                <div className='md:flex hidden flex-col'>
                    <Skeleton height={285} width={600} />
                    <div className='flex flex-row justify-between'>
                        <Skeleton height={10} width={400} />
                        <Skeleton height={10} width={190} />
                    </div>
                </div>

                <div className='md:hidden flex flex-col'>
                    <Skeleton height={285} width={350} />
                    <div className='flex flex-row justify-between'>
                        <Skeleton height={10} width={230} />
                        <Skeleton height={10} width={110} />
                    </div>
                </div>




            </div>}
        </>
                }
            </div >

    <div className='w-1/12 flex justify-center items-center' >
        <i class="fa-solid fa-chevron-right fa-xl " title='Scroll Right' onClick={scrollRight} style={{ cursor: 'pointer' }}></i>
    </div>

        </div >
    );
}

export default ExclusiveVideos;
